import { graphql } from '@apollo/react-hoc';

import fetchLocationsQuery from './graphql/fetchLocationsQuery';
import createLocationMutation from './graphql/createLocationMutation';
import updateLocationMutation from './graphql/updateLocationMutation';
import deleteLocationMutation from './graphql/deleteLocationMutation';

import { SimpleLoadingComponent } from '../../utils/apollo';
import CollegeEventLocation from './view';
import './styles.css';

const createCollegeLocation = graphql(createLocationMutation, {
  name: 'createCollegeLocation',
});

const updateCollegeLocation = graphql(updateLocationMutation, {
  name: 'updateCollegeLocation',
});

const deleteCollegeLocation = graphql(deleteLocationMutation, {
  name: 'deleteCollegeLocation',
});

const graphqlData = graphql(fetchLocationsQuery);

export default SimpleLoadingComponent(
  graphqlData,
  createCollegeLocation,
  updateCollegeLocation,
  deleteCollegeLocation,
)(CollegeEventLocation);
